/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getMerchantUnitOvertimeRuleset} from '../api'

 export const useQueryGetMerchantUnitOvertimeRuleset = createReactQueryHook('getMerchantUnitOvertimeRuleset', getMerchantUnitOvertimeRuleset)
